import angular from 'angular';
import uiRouter from 'angular-ui-router';
import botFlowComponent from './bot-flow.component';

let botFlowModule = angular.module('app.containers.bot-flow', [
  uiRouter
])

.config(($stateProvider) => {
  "ngInject";
  $stateProvider
    .state('botFlow', {
      url: '/bot-flows',
      template: '<bot-flow></bot-flow>'
    });
})

.component('botFlow', botFlowComponent);

export default botFlowModule;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/bot-flow/bot-flow.js
 **/